import {getEnvironment} from '@freckle/educator-entities/ts/config/environment'
import {fancyClient} from '@freckle/educator-entities/ts/openapi-clients'

export function checkLoginStatus(
  retryPeriod: number,
  isOnValidUnloggedUrl: () => boolean,
  defaultLoginPageRetries: number
) {
  const checkAuth = (loginPageRetries?: number | null): void => {
    if (isOnValidUnloggedUrl()) {
      const retriesLeft =
        loginPageRetries === null || loginPageRetries === undefined
          ? defaultLoginPageRetries
          : loginPageRetries - 1
      if (retriesLeft > 0) {
        setTimeout(() => checkAuth(retriesLeft), retryPeriod)
      } else {
        document.location.reload()
        setTimeout(checkAuth, retryPeriod)
      }
    } else {
      fancyClient
        .GET('/2/auth-check')
        .then(() => {
          setTimeout(checkAuth, retryPeriod)
        })
        .catch(() => {
          document.location.reload()
          setTimeout(checkAuth, retryPeriod)
        })
    }
  }
  setTimeout(checkAuth, retryPeriod)
}

export function isProductionEnv(): boolean {
  return getEnvironment(window.location.hostname) === 'production'
}

export function isStaging(): boolean {
  return getEnvironment(window.location.hostname) === 'staging'
}

export function isTestEnv(): boolean {
  return getEnvironment(window.location.hostname) === 'test'
}

export function isLocalhost(): boolean {
  return getEnvironment(window.location.hostname) === 'localhost'
}
